import { FieldType, TableSchema } from '../types';

export const recipeTableSchema: TableSchema = {
  countPerPage: 10,
  fields: [
    {
      name: 'recipe.name',
      field: 'name',
      searchable: true,
      sortable: true,
      type: FieldType.Text,
      defaultSort: true,
    },
  ],
};
